import { Card, CardContent } from '@/components/ui/card'
import type { RunMetrics } from '@/models/agentRunReport'
import { formatCost, formatCount, formatLatency, formatPercent, formatTokens } from './format'

interface Tile {
  label: string
  value: string
  note?: string
}

function tiles(totals: RunMetrics): Tile[] {
  return [
    { label: 'Runs', value: formatCount(totals.runs) },
    {
      label: 'Error rate',
      value: formatPercent(totals.errorRate),
      note: `${formatCount(totals.errors)} failed`,
    },
    {
      label: 'Cancelled',
      value: formatCount(totals.cancelled),
      note: 'stopped by a user',
    },
    { label: 'Median latency', value: formatLatency(totals.latencyP50Ms) },
    { label: 'p95 latency', value: formatLatency(totals.latencyP95Ms) },
    {
      label: 'Tokens',
      value: formatTokens(totals.tokens),
      note: `${formatPercent(totals.cacheReadShare, 0)} from cache`,
    },
    {
      label: 'Cost',
      value: formatCost(totals.costUsd, totals.pricedRuns),
      // Only models in the price table produce a cost, so a bare total would
      // read as a discount rather than as missing data.
      note: totals.unpricedRuns
        ? `${formatCount(totals.pricedRuns)} of ${formatCount(totals.runs)} runs priced`
        : `${formatCost(totals.costPerRun, totals.pricedRuns)} per run`,
    },
  ]
}

export function StatTiles({ totals }: { totals: RunMetrics }) {
  return (
    <div className="grid grid-cols-2 gap-3 md:grid-cols-4 xl:grid-cols-7">
      {tiles(totals).map((tile) => (
        <Card key={tile.label}>
          <CardContent className="p-4">
            <div className="text-ink-500 text-sm">{tile.label}</div>
            <div className="text-2xl font-semibold">{tile.value}</div>
            {tile.note && <div className="text-ink-400 mt-1 text-xs">{tile.note}</div>}
          </CardContent>
        </Card>
      ))}
    </div>
  )
}
